export default function Designchip(){

    return(
        <p className="chip-cont designchip">
            Design
        </p>
    )
}